export const CASE_TYPES = [
  "FLR M", "FLR FP", "FLR HRO", "Admin Rev", "BAIL", "MISC", "DPT",
  "EUSS", "ASYLUM", "FW", "ECLR", "STU", "PSW", "VISIT V", "UT",
  "APPEAL", "PAP", "SW", "SL", "DC", "DP", "CS", "NAT", "SAR",
  "SET M", "SET P", "SET LR", "SET O", "SET DV",
];

export const LEAD_TYPES = [
  "Website", "Phone", "Whatsapp", "Referral", "Returning Client", "Social Media", "Agent / Partner",
];

export const FILE_STATUSES = [
  "Open", "Closed", "In-progress", "In Court", "Waiting on Client", "Appealed", "Dropped", "Settled",
];

export const PRIORITIES = ["Low", "Medium", "High", "Urgent"];

// Must match the server stage names in artifacts/api-server/src/routes/stages.ts
export const APPEAL_STAGES = [
  "Initial meeting",
  "Submission of appeal",
  "Respondent bundle received",
  "Respondent bundle reviewed",
  "Appellant bundle preparation",
  "Court review",
  "Substantive hearing",
  "Decision",
];

export const DEFAULT_STAGES = [
  "Initial meeting",
  "Document collection",
  "Documents reviewed",
  "Application preparation",
  "Submission of application",
];

export function getStagesForCaseType(caseType: string | null | undefined) {
  if (!caseType) return DEFAULT_STAGES;
  return caseType.toUpperCase().includes("APPEAL") ? APPEAL_STAGES : DEFAULT_STAGES;
}

// RBAC
export type UserRole = "owner" | "owner_2" | "staff";

export const ROLE_LABELS: Record<UserRole, string> = {
  owner: "Owner",
  owner_2: "Owner 2.0",
  staff: "Staff",
};

export function canWrite(role: string | null | undefined): boolean {
  return role === "owner";
}

export function canSeeFinance(role: string | null | undefined): boolean {
  return role === "owner" || role === "owner_2";
}

export function canManageUsers(role: string | null | undefined): boolean {
  // Owner: read+write; Owner 2.0: read-only; Staff: blocked
  return role === "owner" || role === "owner_2";
}
